import ButtonLinkPrimary from "./ButtonLinkPrimary";
import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";

export default class Label  extends ButtonLinkPrimary{

    static propTypes = {
        positionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        className: PropTypes.string,
        customerName: PropTypes.string.isRequired,
        buttonType: PropTypes.string,
        htmlFor: PropTypes.string,
		onClick: PropTypes.func,
	};

    render() {
        if (this.state['loading']) {
            return null;
        }
		const { onClick, htmlFor, className } = this.props;

		return (
            <label
                htmlFor = {htmlFor}
                className={classNames(className, {'disabled': this.props.uploadedCv})}
                style={this.state['button']}
                onMouseEnter ={() => this.changeToHoverStyle(true)}
                onMouseLeave ={() => this.changeToHoverStyle(false)}
				onClick={onClick}
            >
                {this.props.children}
            </label>
        );
    }
}
